import { useTranslation } from 'react-i18next';

export const useAppTranslations = useTranslation;
